import { getAxiosInstance, getQueryStringFromObject } from "./common.service";

async function getReleases(query = {}) {
    try {
        const axios = await getAxiosInstance();
        let queryString = await getQueryStringFromObject(query);
        if (queryString) {
            queryString = '?' + queryString;
        } else {
            queryString = '';
        }
        let response = await axios.get('/releases' + queryString);
        return response.data;
    } catch (error) {
        console.error(error);
    }
}

async function postReleaseAnswer(data) {
    try {
        const axios = await getAxiosInstance();
        let response = await axios.post('/release_answers', data);
        return response.data;
    } catch (error) {
        console.error(error);
    }
}

export {
    getReleases,
    postReleaseAnswer
}
